import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import FormularioArt from '../Formularios/FormularioArt';

const ModalEdicionContrato = ({ show, onClose, onSuccess, contrato, clientData }) => {
    const [formKey, setFormKey] = useState(0);
    const wasShowing = useRef(false);

    // Reseteamos el formulario solo al abrir el modal de nuevo
    useEffect(() => {
        if (show && !wasShowing.current) {
            setFormKey(prev => prev + 1);
        }
        wasShowing.current = show;
    }, [show]);

    if (!show) return null;

    /**
     * handleSuccess
     * Cierra el modal e informa al padre directamente los datos para la vinculación.
     */
    const handleSuccess = (msg, data) => {
        if (onSuccess) onSuccess(msg, data);
        onClose(); // CIERRE DIRECTO
    };

    const displayContractNum = contrato?.nContratoVinculado || contrato?.nContrato;

    return createPortal(
        <div className="fixed inset-0 bg-gray-900 bg-opacity-60 z-[1010] flex items-center justify-center p-4 backdrop-blur-sm text-left">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl h-auto max-h-[95vh] flex flex-col overflow-hidden animate-fade-in border border-gray-100">
                
                {/* CABECERA */}
                <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 bg-indigo-50/50 shrink-0">
                    <div className="flex items-center gap-3">
                        <span className="bg-indigo-100 text-indigo-600 p-2 rounded-lg shrink-0">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                            </svg>
                        </span>
                        <div>
                            <h3 className="text-xl font-bold text-gray-800 leading-none">
                                {contrato?.id ? 'Editar Contrato ART' : 'Emitir Contrato ART'}
                            </h3>
                            <p className="text-xs text-indigo-800/70 font-bold mt-1 tracking-wide uppercase">
                                {displayContractNum ? `Contrato: ${displayContractNum}` : 'Nuevo Registro'}
                            </p>
                        </div>
                    </div>
                    <button 
                        onClick={onClose} 
                        className="text-gray-400 hover:text-gray-600 transition-colors p-1.5 rounded-full hover:bg-white/80"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>

                <div className="overflow-y-auto flex-grow bg-white custom-scrollbar p-6">
                    <FormularioArt 
                        key={formKey} 
                        clientData={clientData}
                        initialData={contrato} 
                        onCancel={onClose}
                        onSuccess={handleSuccess}
                        bypassSuccessScreen={true} // FORZAMOS EL BYPASS EN EL CONTEXTO DEL MODAL
                    />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalEdicionContrato;